// The tab URL for the job on screen. Returns null when the store still holds
// a different job, so opening one job cannot rewrite the address bar to the
// previous one.
export const jobTabPath = (jobObject, tabId, currentPath) => {
  const id = jobObject && jobObject.attributes && jobObject.attributes.id;
  if (!id || !tabId || !currentPath || currentPath.indexOf(id) === -1) return null;
  return `/dashboard/jobs/${id}/${tabId}`;
};
